import type { Media } from '@wineryxplorer/shared';

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};

const formatDate = (date: Date): string =>
  new Date(date).toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

export interface MediaDetailMetadataProps {
  media: Media;
}

export const MediaDetailMetadata = ({ media }: MediaDetailMetadataProps) => (
  <div>
    <span className="text-sm font-medium text-gray-700 block mb-2">Details</span>
    <div className="text-sm text-gray-600 space-y-1">
      <div className="flex justify-between">
        <span>File size:</span>
        <span>{formatFileSize(media.sizeBytes)}</span>
      </div>
      {media.width && media.height && (
        <div className="flex justify-between">
          <span>Dimensions:</span>
          <span>
            {media.width} × {media.height}
          </span>
        </div>
      )}
      <div className="flex justify-between">
        <span>Type:</span>
        <span>{media.mimeType}</span>
      </div>
      <div className="flex justify-between">
        <span>Uploaded:</span>
        <span>{formatDate(media.createdAt)}</span>
      </div>
      <div className="flex justify-between">
        <span>Modified:</span>
        <span>{formatDate(media.updatedAt)}</span>
      </div>
    </div>
  </div>
);
